import * as React from "react";
import { NavItemData, onNavClick } from "../nav.tsx";
import { useCommonDialogs } from "../../CommonDialogsProvider.tsx";
import { NavCount } from "../NavCount.tsx";

interface Props {
  item: NavItemData;
}

export const MoreMenuItem: React.FC<Props> = ({ item }) => {
  const commonDialogs = useCommonDialogs();
  return (
    <a className="more-sheet-item" href={item.href} onClick={onNavClick(item, commonDialogs)}>
      {item.icon}
      {item.label}
      {item.countKind && <NavCount kind={item.countKind} />}
    </a>
  );
};
